import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Form, Input, Button, Typography, Card, Alert } from 'antd';
import { MailOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Auth = () => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { signInWithEmail } = useAuth();

  const handleSubmit = async (values) => {
    try {
      setMessage("");
      setLoading(true);
      const { error } = await signInWithEmail(values.email);
      if (error) throw error;
      setMessage("Check your email for the magic link!");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <Card className="auth-form">
        <Title level={2} style={{ textAlign: 'center' }}>Welcome Back</Title>
        <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 24 }}>
          Sign in via magic link with your email below
        </Text>

        <Form
          name="auth-form"
          onFinish={handleSubmit}
          layout="vertical"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input 
              prefix={<MailOutlined />} 
              placeholder="Your email" 
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              Send Magic Link
            </Button>
          </Form.Item>

          {message && (
            <Alert
              message={message}
              type={message.includes("error") ? "error" : "success"}
              showIcon
            />
          )}
        </Form>
      </Card>
    </div>
  );
};

export default Auth;
